




















































































































































import {Mixins, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import Component from 'vue-class-component'
import Tooltip from '@/components/tooltip/Tooltip.vue'
import TooltipMobileContent from '@/components/tooltip/TooltipMobileContent.vue'
import {GasCalculatorTarget} from '@/model/resource/GasCalculatorTarget'
import {$} from '@/facade'

@Component({
  components: {
    TooltipMobileContent,
    Tooltip,
  },
})
export default class GasCalculatorTable extends Mixins(MixinScreenSize) {
  @Prop({type: Number, required: true}) dailyAmount!: number
  @Prop({type: Number, required: true}) weeklyAmount!: number
  @Prop({type: Number, required: true}) monthlyAmount!: number
  @Prop({type: Number, required: true}) yearlyAmount!: number
  @Prop({type: Number, required: true}) gasPriceInDollar!: number
  @Prop({type: GasCalculatorTarget, required: true})
  candidate!: GasCalculatorTarget
  isTooltipMobileOpen = false

  get lastUpdateTime() {
    const timestamp = this.candidate?.lastDailyGasRateUpdatedTime
    if (!timestamp) return ''

    const date = new Date(timestamp)

    return `${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(
      date.getUTCDate()
    ).padStart(2, '0')}-${date.getUTCFullYear()} | ${String(
      date.getUTCHours()
    ).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(
      2,
      '0'
    )}:${String(date.getUTCSeconds()).padStart(2, '0')} (UTC)`
  }

  get tooltipMobileContent() {
    const statusClass = this.dailyGasRateIncreased
      ? 'trend-status__up'
      : this.dailyGasRateDecreased
      ? 'trend-status__down'
      : 'trend-status__same'

    const statusLabel = this.dailyGasRateIncreased
      ? '▲ Increased'
      : this.dailyGasRateDecreased
      ? '▼ Decreased'
      : 'No change'

    const statusHTML = `<span class="trend-status ${statusClass} text-xl flex items-center justify-center">${statusLabel}</span>`

    const content = this.candidate.lastDailyGasRateUpdatedTime
      ? $.translate(
          'components.gasCalculator.gasCalculatorTable.trendTooltip',
          {
            dailyGasRateUpdatedTime: this.lastUpdateTime,
          }
        )
      : $.translate('components.gasCalculator.gasCalculatorTable.failedToFetch')

    return `${statusHTML}<br>${content}`
  }

  get rewardData() {
    return {
      daily: {
        value: this.dailyAmount,
        period: 'components.gasCalculator.gasCalculatorTable.gasRewardsPerDay',
      },
      weekly: {
        value: this.weeklyAmount,
        period: 'components.gasCalculator.gasCalculatorTable.gasRewardsPerWeek',
      },
      monthly: {
        value: this.monthlyAmount,
        period:
          'components.gasCalculator.gasCalculatorTable.gasRewardsPerMonth',
      },
      yearly: {
        value: this.yearlyAmount,
        period: 'components.gasCalculator.gasCalculatorTable.gasRewardsPerYear',
      },
    }
  }

  get isSameDailyAmount() {
    const c = this.candidate
    return (
      c?.dailyGasRate === c?.lastDailyGasRate || !c?.lastDailyGasRateUpdatedTime
    )
  }

  get dailyGasRateIncreased() {
    const c = this.candidate
    return c?.dailyGasRate != null &&
      c?.lastDailyGasRate != null &&
      c.dailyGasRate > c.lastDailyGasRate
      ? true
      : false
  }

  get dailyGasRateDecreased() {
    const c = this.candidate
    return c?.dailyGasRate != null &&
      c?.lastDailyGasRate != null &&
      c.dailyGasRate < c.lastDailyGasRate
      ? true
      : false
  }

  get tooltipLabel() {
    if (this.dailyGasRateIncreased) {
      return '▲'
    } else if (this.dailyGasRateDecreased) {
      return '▼'
    } else {
      return '-'
    }
  }

  get tooltipButtonClass() {
    if (this.dailyGasRateIncreased) {
      return 'text-green-500 bg-transparent font-bold text-lg flex items-center justify-center text-center w-2'
    } else if (this.dailyGasRateDecreased) {
      return 'text-red-500 bg-transparent font-bold text-lg flex items-center justify-center text-center w-2'
    } else {
      return 'bg-gray-300 text-gray-600 bg-transparent font-bold text-lg flex items-center justify-center text-center w-2'
    }
  }

  calculateDollar(gas: number | string) {
    return (Number(gas) * this.gasPriceInDollar).toFixed(2)
  }

  setIsTooltipMobileOpen(val: boolean) {
    this.isTooltipMobileOpen = val
  }
}
